import {
  getOrganizationBillingData,
  setOrganizationBillingDetails,
} from '../helpers/API';
import * as firebaseHelpers from '../helpers/Firebase/';
import * as types from './actionTypes';
import { setLoading } from './loaderActions';

export function updateBillingMethod(formData) {
  return async dispatch => {
    try {
      dispatch(setLoading(true));
      await setOrganizationBillingDetails(formData);
    } catch (e) {
      console.error(e);
      alert(e.message || e);
    }
    await dispatch(loadBillingDetails());
    dispatch(setLoading(false));
  };
}

export function loadBillingHistory() {
  return async (dispatch, getState) => {
    const organization = await firebaseHelpers.getCurrentUser(false);
    const { accountType } = getState().userReducer;

    if (organization && accountType === 0) {
      firebaseHelpers.watchCollectionChanges(
        `organizations/${organization.uid}/billing`,
        (billingHistory = []) => {
          dispatch({
            type: types.LOAD_BILLING_HISTORY,
            billingHistory,
          });
        }
      );
    }
  };
}

export function loadBillingDetails() {
  return async dispatch => {
    const billingData = await getOrganizationBillingData();
    const { details } = billingData || {};
    billingData.details.accountVerified = details.verified;
    dispatch({
      type: types.LOAD_BILLING_DETAILS,
      billingDetails: billingData.details,
    });
  };
}
